module.exports = [{
      plugin: require('../../../.cache/yarn/cache/gatsby-plugin-rudderstack-npm-1.1.2-3a2ac2f536-ce4dd9b995.zip/node_modules/gatsby-plugin-rudderstack/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"23q2RYgM6ev2bBShYbfvfFtBwIg","devKey":"23q2RYgM6ev2bBShYbfvfFtBwIg","trackPage":true,"trackPageDelay":50,"dataPlaneUrl":"https://tradeschrzxqe.dataplane.rudderstack.com","delayLoad":false,"delayLoadTime":1000,"manualLoad":false,"loadType":"default"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../.cache/yarn/unplugged/gatsby-virtual-e152a88e2a/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
